export default {
    username: "Username",
    password: "Password",
    button: "Sign In",
    error: "Error logging in, check your information",
    page_title: "Kevi | Login",
    pattern_alt: "Decorative vector",
    logo_alt: "Kevi Logo",
    promo_alt: "Promotional image",
    username_placeholder: "Enter your username",
    password_placeholder: "**********************",
    forgot_password: "Forgot password?",
    contact_support: "Contact support",
    access_account_title: "Access your account",
    access_account_subtitle:
        "Manage your campaigns, automate your actions, and build customer loyalty.",
    auth_granted_title: "Authorization Granted",
    auth_granted_subtitle:
        "You have successfully authorized <strong>{0}</strong>.",
    go_to_client: "Go to {0}",
    auth_access_title: "Authorize Access",
    logged_in_as: "You are logged in as <strong>{0}</strong>.",
    authorize_access_question:
        "Do you want to authorize access to <strong>{0}</strong>?",
    yes_authorize: "Yes, Authorize",
    switch_account: "Not you? Switch account",
    login_to_authorize:
        "Log in to Kevi to authorize access to <strong>{0}</strong>.",
    authorize_button: "Authorize",
    invalid_redirect_uri: "Invalid redirect URL.",
    auth_code_generation_failed: "Failed to generate authorization code.",
    session_expired: "Session expired. Please log in again.",
    server_connection_error: "Error connecting to server.",
    oauth_access_code_missing:
        "Authorization failed. Access code was not returned.",
    redirect_missing_info:
        "Redirect failed. Application information is missing.",
    popup_blocked:
        "The redirect was blocked. Please enable pop-ups for this site.",
    twofa: {
        title: "2-FACTOR AUTHENTICATION",
        subtitle: "Enter the 6-digit code generated in your authenticator app",
        verify_button: "Verify",
        use_backup: "Or use one of your backup codes.",
        click_here: "Click here.",
        error_auth:
            "Authorization failed. Access code not found after verification.",
        error_invalid: "Invalid or expired code. Please try again.",
        error_too_many: "Too many attempts. Please sign in with your password again.",
        error_expired: "The time to confirm the code is over. Please sign in with your password again.",
        error_code_used: "This recovery code has already been used.",
    },
    backup: {
        title: "Enter your backup code",
        subtitle: "Enter one of your 8-digit backup codes",
        use_authenticator: "If you prefer, use one of your ",
        code_link: "authenticator codes",
    },
    recovery: {
        link: "Reset password",
        title: "Reset password",
        subtitle: "Enter the username or email of your account. We will send a code so you can create a new password.",
        identifier_label: "Username or email",
        identifier_placeholder: "Enter your username or email",
        continue: "Continue",
        choose_title: "Choose a channel",
        choose_subtitle: "You have two contact methods. Where should we send the code?",
        email: "Email",
        sms: "SMS",
        code_title: "Enter the code",
        code_subtitle: "We sent a 6-digit code to {0}.",
        resend_prefix: "Didn't get the code?",
        resend_action: "Click here.",
        verify: "Verify",
        password_title: "Create a new password",
        password_hint: "Use at least 8 characters.",
        new_password: "New password",
        repeat_password: "Repeat the new password",
        save: "Save new password",
        success_title: "Password changed successfully!",
        success_subtitle: "Use the new password to sign in.",
        back_to_login: "Back to login",
        blocked_title: "This password cannot be recovered",
        blocked_subtitle: "This account has no verified email or phone. Ask an administrator at your company to set a new password for you.",
        blocked_back: "Back to login",
        invalid_code: "Invalid or expired code. Try again.",
        mismatch: "The passwords do not match.",
        weak: "Use at least 8 characters.",
        too_many: "Too many attempts. Try again later.",
        send_failed: "The code could not be sent. Try again.",
        code_valid: "It is valid for 15 minutes.",
        change_identifier: "Back",
        resend_in: "Resend in {0}",
        resent: "We sent you a new code.",
        expired: "The code has expired. Request a new code.",
        too_many_attempts: "Too many attempts with this code. Request a new code.",
        network: "Could not connect. Try again.",
    },
};
